import { z } from 'zod';

import { client } from '~shared/api';

import { SettingsDto, SettingsDtoSchema, SettingsUpdateAllDto, SettingsUpdateDto } from '../model';

export async function loadSettings(): Promise<{ [key: string]: SettingsDto }> {
	const res: { [key: string]: SettingsDto } = {};
	const data = await client.get('/settings');
	for (const row of z.array(SettingsDtoSchema).parse(data)) {
		res[row.key] = row;
	}
	return res;
}

export async function updateSetting(entity: SettingsUpdateDto): Promise<void> {
	await client.post('/settings', entity);
}

export async function updateSettingsAll(settings: SettingsUpdateAllDto): Promise<void> {
	await client.put('/settings', settings);
}

export async function getSettings(key: string): Promise<SettingsDto> {
	const data = await client.get(`/settings/${key}`);
	return SettingsDtoSchema.parse(data);
}
